module.exports = __webpack_public_path__ + "img/lyra.c085eb36.png";